/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default [
  {
    url: '/',
    name: 'Home',
    slug: 'home',
    icon: 'HomeIcon',
    tenantType: null,
    roles:[]
  },
  {
    url: '/portfolio',
    name: 'Portfolios',
    slug: 'portfolio',
    icon: 'BookOpenIcon',
    tenantType: 'ENERGY',
    roles:['PORTFOLIO_VIEW']
  },
  {
    url: '/limit',
    name: 'Limite e Exposição',
    slug: 'portfolio',
    icon: 'BookOpenIcon',
    tenantType: 'ENERGY',
    roles:['LIMIT_VIEW']
  },
  {
    url: '/empresas',
    name: 'Empresas',
    slug: 'empresas',
    icon: 'CodeIcon',
    tenantType: null,
    roles:['COMPANY_VIEW']
  },
  {
    url: '/relatorio-credito',
    name: 'Relatório',
    slug: 'relatorio-credito',
    icon: 'DatabaseIcon',
    tenantType: 'FINANCE',
    roles:['COMPANY_VIEW']
  },
  {
    name: 'Propostas',
    slug: 'proposeAdd',
    icon: 'DatabaseIcon',
    tenantType: 'ENERGY',
    roles:['PROPOSE_VIEW', 'PROPOSE_ADD'],
    submenu: [
      {
        url: '/propose',
        name: 'Listar Propostas',
        slug: 'proposeList',
        tenantType: 'ENERGY',
        roles:['PROPOSE_VIEW']
      },
      {
        url: '/propose-add',
        name: 'Nova Proposta',
        slug: 'proposeAdd',
        tenantType: 'ENERGY',
        roles:['PROPOSE_ADD']
      }
    ]
  },
  {
    name: 'Controle de Garantias',
    icon: 'Edit3Icon',
    tenantType: 'ENERGY',
    roles:['GUARANTEE_VIEW', 'GUARANTEE_ADD'],
    submenu: [
      {
        url: '/guarantee/upload',
        name: 'Upload de Garantias',
        slug: 'guarantee',
        tenantType: 'ENERGY',
        roles:['GUARANTEE_ADD']
      },
      {
        url: '/guarantee',
        name: 'Lista de Garantias',
        slug: 'guarantee',
        tenantType: 'ENERGY',
        roles:['GUARANTEE_VIEW']
      },
      {
        url: '/guarantee/stats',
        name: 'Quadro de Análise',
        slug: 'guarantee-stats',
        tenantType: 'ENERGY',
        roles:['GUARANTEE_VIEW']
      }
    ]
  },
  {
    name: "Dados Históricos",
    icon: 'LayersIcon',
    tenantType: 'ENERGY',
    roles:['TRADER_VIEW', 'GENERATOR_VIEW'],
    submenu: [
      {
        url: '/ccee/comercializadoras',
        name: 'Comercializadoras',
        slug: 'ccee',
        tenantType: 'ENERGY',
        roles:['TRADER_VIEW']
      },
      {
        url: '/ccee/geradoras',
        name: 'Geradoras',
        slug: 'ccee',
        tenantType: 'ENERGY',
        roles:['GENERATOR_VIEW']
      },
    ],
  },
  {
    name: 'Robôs',
    icon: 'PlusSquareIcon',
    url: '/robots',
    slug: 'robots',
    tenantType: 'ENERGY',
    roles:['ROBOT_VIEW']
  }
]
